import React, { Component } from "react"

import MetaTags from "react-meta-tags"
import CarouselPage from "./CarouselPage"

// import images
import logodark from "../../assets/images/kattam-login.png"
import logolight from "../../assets/images/logo-light.png"
import { Col, Container, Row } from "reactstrap"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { connect } from "react-redux"

class GroupReportConfirmation extends Component {

  constructor(props) {
    super(props)

    this.state = {
      registrationToken: ''
    }
  }

  componentDidMount() {

    const { match: { params }, } = this.props
    if (params && params.token) {
      this.setState({ registrationToken: params.token })
    }

  }

  render() {

    let token = "/report-registration/" + this.state.registrationToken

    return (
      <React.Fragment>
        <div>
          <MetaTags>
            <title> Report | Kattam</title>
          </MetaTags>
          <Container fluid className="p-0">
            <Row className="g-0">

              <CarouselPage />

              <Col cl={5}>
                <div className="auth-full-page-content p-md-5 p-4">
                  <div className="w-100">
                    <div className="d-flex flex-column h-100">
                      <div >

                        <img
                          src={logodark}
                          alt=""
                          height="80"
                          className="auth-logo-dark" />


                      </div>
                      <div>

                      No 18, Capitol Singapore,
                      13, Stamford Road,
                        SINGAPORE 178905
                      </div>
                      <div className="my-auto">
                        <div className="text-center">
                          {(
                            <div>
                              <h4 className="text-success mb-4">
                              </h4>
                              <div className="avatar-md mx-auto mb-4">

                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                              </div>
                              <p>
                                Thank you for Submitting your details
                              </p>
                              <p>
                                Click here to{" "}
                                <Link
                                  to={token}
                                  className="fw-medium text-primary"
                                >
                                  {" "}
                                  Create New Report
                                </Link>{" "}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mt-4 mt-md-5 text-center">
                        <p className="mb-0">
                          © {new Date().getFullYear()} Kattam. All rights
                          reserved{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )

  }
}


export default connect()(GroupReportConfirmation)
